import {Box, Chip} from "@mui/material";
import {ImportValidationFailure} from "../../../Component/Model/Dto/Staging/ImportValidationFailure";
import {failureLabel} from "./ValidationFailureLabels";

export const ValidationFailuresCell = ({value}: { value: ImportValidationFailure.Dto[] }) => (
    <Box sx={{display: "flex", flexWrap: "wrap", gap: 1}}>
        {value.map((failure, index) => (
            <Chip key={index} label={failureLabel(failure)} size="small" color="error" variant="outlined"/>
        ))}
    </Box>
);
